/* ============================================================
   ENDORA GUT PDP — shared JS
   One file, deferred, loaded once for every endora-gut-* section.
   Each behavior below is self-contained and guarded, so sections
   can be reordered/removed in the customizer without breaking
   the others.
   ============================================================ */

(function () {
  'use strict';

  /* ── np-gallery: lightweight product gallery ── */
  function initGallery() {
    var root = document.getElementById('npGallery');
    if (!root || root.dataset.npGalleryInit === '1') return;
    root.dataset.npGalleryInit = '1';

    // 10 images — exact order + version params from the live /products/gut gallery.
    var IMAGES = [
      { v: '1781817964', file: 'ChatGPT_Image_Jun_19_2026_02_25_40_AM.png' },
      { v: '1781906102', file: 'ChatGPT_Image_Jun_20_2026_02_54_42_AM.png' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_47_31AM.png' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_46_33AM.png' },
      { v: '1787708457', file: 'endora-gut-timeline-image.webp' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_46_49AM.png' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_46_59AM.png' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_47_09AM.png' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_47_16AM.png' },
      { v: '1781553021', file: 'ChatGPTImageJun16_2026_12_47_23AM.png' }
    ];
    var BASE = 'https://www.endora-us.com/cdn/shop/files/';
    function mainUrl(i, w) { return BASE + IMAGES[i].file + '?v=' + IMAGES[i].v + '&width=' + w; }

    var mainImg = root.querySelector('#npGalleryMainImg');
    var thumbsRow = root.querySelector('#npGalleryThumbs');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.np-gallery__thumb'));
    var current = 0;

    function setActive(index) {
      if (index < 0) index = IMAGES.length - 1;
      if (index >= IMAGES.length) index = 0;
      current = index;
      // single width=700, no srcset — every gallery image is one request at the same
      // size the markup + preload use (see snippet comment).
      mainImg.removeAttribute('srcset');
      mainImg.src = mainUrl(index, 500);
      thumbs.forEach(function (t, i) { t.classList.toggle('np-gallery__thumb--active', i === index); });
      var activeThumb = thumbs[index];
      if (activeThumb && thumbsRow) {
        var left = activeThumb.offsetLeft - (thumbsRow.clientWidth - activeThumb.clientWidth) / 2;
        thumbsRow.scrollTo({ left: left, behavior: 'smooth' });
      }
    }

    if (thumbsRow) {
      thumbsRow.addEventListener('click', function (e) {
        var btn = e.target.closest('.np-gallery__thumb');
        if (!btn) return;
        var idx = thumbs.indexOf(btn);
        if (idx !== -1) setActive(idx);
      });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('.np-gallery__arrow--prev')) setActive(current - 1);
      if (e.target.closest('.np-gallery__arrow--next')) setActive(current + 1);
    });

    var touchStartX = null;
    var mainWrap = root.querySelector('.np-gallery__main');
    mainWrap.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) setActive(dx < 0 ? current + 1 : current - 1);
      touchStartX = null;
    }, { passive: true });
  }

  /* ── ep-price-block: live price display driven by Kaching's selected tier ── */
  function initPriceBlock() {
    var elPrice = document.getElementById('ep-price-current');
    if (!elPrice || elPrice.dataset.init === '1') return;
    elPrice.dataset.init = '1';

    var elCompare  = document.getElementById('ep-price-compare');
    var elBadge    = document.getElementById('ep-price-badge');
    var elShipping = document.getElementById('ep-price-shipping');
    var SVG_TRUCK  = '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="10" height="8" rx="1"/><path d="M11 6h2.5l1.5 3v3h-4V6z"/><circle cx="4" cy="13" r="1.2"/><circle cx="13" cy="13" r="1.2"/></svg>';
    var META = window.endoraGutPriceMeta || [];
    var _lastIdx = 1;

    function getSelectedIdx() {
      var bars = document.querySelectorAll('.kaching-bundles__bars--horizontal > .kaching-bundles__bar');
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].classList.contains('kaching-bundles__bar--selected')) return i;
      }
      return _lastIdx;
    }
    function isSubActive() {
      var subBar = document.querySelector('.kaching-bundles__subscriptions .kaching-bundles__bar');
      return subBar && subBar.getAttribute('aria-checked') === 'true';
    }
    function render(idx) {
      var meta = META[idx] || META[0];
      if (!meta) return;
      var sub = isSubActive();
      var price = sub ? meta.subPrice : meta.price;
      elPrice.textContent = '$' + Number(price).toFixed(2) + (meta.perBottle ? '/bottle' : '');
      var compare = sub ? meta.subCompare : meta.compare;
      var badge = sub ? (meta.saved ? meta.saved + ' + 10% Sub' : '10% Sub') : meta.saved;
      elCompare.textContent = compare || '';
      elCompare.style.display = compare ? '' : 'none';
      elBadge.textContent = badge || '';
      elBadge.style.display = badge ? '' : 'none';
      elShipping.innerHTML = SVG_TRUCK + ' Free Shipping';
      elShipping.className = 'ep-price-block__shipping ep-price-block__shipping--free';
    }
    function onAction() {
      setTimeout(function () {
        var idx = getSelectedIdx();
        _lastIdx = idx;
        render(idx);
      }, 150);
    }
    function boot() {
      var bars = document.querySelectorAll('.kaching-bundles__bars--horizontal > .kaching-bundles__bar');
      if (bars.length < 1) return false;
      var idx = getSelectedIdx();
      _lastIdx = idx;
      render(idx);
      document.addEventListener('click', onAction, true);
      document.addEventListener('touchend', onAction, true);
      return true;
    }
    if (!boot()) {
      var n = 0, t = setInterval(function () { if (boot() || ++n >= 20) clearInterval(t); }, 500);
    }
  }

  /* ── Ship date: today if Mon-Fri, else next Monday ── */
  function initShipDate() {
    var el = document.getElementById('ep-ship-date');
    if (!el || el.dataset.init === '1') return;
    el.dataset.init = '1';
    var d = new Date();
    if (d.getDay() === 6) d.setDate(d.getDate() + 2);
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    el.textContent = days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
  }

  /* ── Sticky add-to-cart bar: desktop trigger = mechanism section, mobile = reviews ── */
  function initStickyBar() {
    if (window.self !== window.top) return;
    var sticky = document.querySelector('.endora-gut-sticky');
    if (!sticky || sticky.dataset.init === '1') return;
    sticky.dataset.init = '1';

    var triggerDesktop = document.querySelector('.ng-soil');
    var triggerMobile = document.querySelector('.np-loved');
    if (!triggerDesktop && !triggerMobile) return;

    function getTrigger() {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile && triggerMobile) return triggerMobile;
      return triggerDesktop || triggerMobile;
    }
    function update() {
      var trigger = getTrigger();
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      sticky.classList.toggle('endora-gut-sticky--on', rect.top <= window.innerHeight);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ── Guarantee note under the Kaching add-to-cart button ── */
  function initGuaranteeNote() {
    var GUARANTEE_TEXT = '90-Day Money Back Guarantee';
    function styleNote(note) {
      note.style.setProperty('display', 'block', 'important');
      note.style.setProperty('width', '100%', 'important');
      note.style.setProperty('text-align', 'center', 'important');
      note.style.setProperty('font-family', 'Montserrat, -apple-system, sans-serif', 'important');
      note.style.setProperty('font-size', '11px', 'important');
      note.style.setProperty('font-weight', '400', 'important');
      note.style.setProperty('line-height', '1.2', 'important');
      note.style.setProperty('color', '#201C13', 'important');
      note.style.setProperty('opacity', '0.75', 'important');
      note.style.setProperty('margin-top', '0px', 'important');
    }
    function ensureNote(btn) {
      // Our own markup already carries the sub-line (.ep-atc__sub) — don't double it.
      if (btn.querySelector('.ep-atc__sub')) return;
      if (btn.dataset.guaranteeNoteAdded === '1' && btn.querySelector('.atc-gut-guarantee-note')) return;
      btn.style.setProperty('flex-direction', 'column', 'important');
      btn.style.setProperty('gap', '0px', 'important');
      btn.style.setProperty('height', 'auto', 'important');
      var existing = btn.querySelector('.atc-gut-guarantee-note');
      if (existing) return;
      var note = document.createElement('span');
      note.className = 'atc-gut-guarantee-note';
      note.textContent = GUARANTEE_TEXT;
      styleNote(note);
      btn.appendChild(note);
      btn.dataset.guaranteeNoteAdded = '1';
    }
    function scan() {
      // Primary target is our own ATC button (#endora-gut-atc). The kaching-* selectors
      // are fallbacks in case a future Kaching config renders its own submit button.
      var buttons = document.querySelectorAll('#endora-gut-atc, #endora-gut-protocol button[type="submit"], .kaching-bundles__add-to-cart, .kaching-bundles__submit');
      for (var i = 0; i < buttons.length; i++) ensureNote(buttons[i]);
    }
    scan();
    // The button lives in the buy column; only Kaching re-rendering it matters, so
    // watch that subtree, not the whole page. Stop once Kaching has settled.
    var scope = document.querySelector('.endora-gut-atf__info') || document.body;
    var observer = new MutationObserver(scan);
    observer.observe(scope, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 12000);
  }

  /* ── FAQ accordions (shared by endora-gut-hacc and endora-gut-faq) ──
     Single-open-per-group: opening one item closes the others in the same
     accordion container, matching the original np-hacc behavior. */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var q = e.target.closest('.np-hacc__q, .np-faq__q');
      if (!q) return;
      var group = q.closest('.np-hacc, .np-faq');
      if (!group) return;
      var a = document.getElementById(q.dataset.target);
      if (!a) return;
      var qSel = q.classList.contains('np-hacc__q') ? '.np-hacc__q' : '.np-faq__q';
      var aSel = q.classList.contains('np-hacc__q') ? '.np-hacc__a' : '.np-faq__a';
      var isOpen = a.classList.contains('is-open');
      group.querySelectorAll(aSel).forEach(function (el) { el.classList.remove('is-open'); });
      group.querySelectorAll(qSel + ' svg').forEach(function (el) { el.classList.remove('is-open'); });
      group.querySelectorAll(qSel).forEach(function (el) { el.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        a.classList.add('is-open');
        q.setAttribute('aria-expanded', 'true');
        var svg = q.querySelector('svg');
        if (svg) svg.classList.add('is-open');
      }
    }, true);
  }

  /* ── np-pdfmodal: research doc modal ── */
  function initPdfModal() {
    var modal = document.getElementById('np-pdfmodal');
    if (!modal || modal.dataset.npPdfmodalInit === '1') return;
    modal.dataset.npPdfmodalInit = '1';
    var frame = document.getElementById('np-pdfmodal-frame');

    function openModal(url) {
      frame.src = url;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('np-pdfmodal-lock');
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('np-pdfmodal-lock');
      frame.src = '';
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pdfmodal-open]');
      if (trigger) {
        e.preventDefault();
        openModal(trigger.getAttribute('data-pdfmodal-open'));
        return;
      }
      if (e.target.closest('[data-pdfmodal-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  }

  /* ── np-ing: ingredient "+" toggle (single-open per card grid) ── */
  function initIngredientToggle() {
    var container = document.querySelector('.np-ing__cards');
    if (!container || container.dataset.ingBound) return;
    container.dataset.ingBound = '1';
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.np-ing__plus');
      if (!btn) return;
      var desc = document.getElementById(btn.dataset.target);
      if (!desc) return;
      var isOpen = desc.classList.contains('is-open');
      Array.from(container.querySelectorAll('.np-ing__desc')).forEach(function (d) { d.classList.remove('is-open'); });
      Array.from(container.querySelectorAll('.np-ing__plus')).forEach(function (b) { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); });
      if (!isOpen) {
        desc.classList.add('is-open');
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ── ep-segrev: symptom filter chips switch review panels ── */
  function initSegrevTabs() {
    var wrap = document.querySelector('.ep-segrev');
    if (!wrap || wrap.dataset.segrevBound) return;
    var chips = wrap.querySelectorAll('.ep-segrev__chip');
    var panels = wrap.querySelectorAll('.ep-segrev__panel');
    if (!chips.length) return;
    wrap.dataset.segrevBound = '1';
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var target = this.dataset.target;
        chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.id === target); });
      });
    });
  }

  /* ── "read more" toggle on np-loved review cards ── */
  function initReadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.np-loved__rcard-readmore');
      if (!btn) return;
      var card = btn.closest('.np-loved__rcard');
      if (!card) return;
      var expanded = card.classList.toggle('np-loved__rcard--expanded');
      btn.textContent = expanded ? 'show less' : 'read more';
    }, true);
  }

  /* ── np-trio: paginated testimonial grid (3-up desktop, 1-up mobile) ── */
  function initTrioNav() {
    var section = document.querySelector('.np-trio');
    if (!section || section.dataset.trioBound) return;
    var cards = Array.prototype.slice.call(section.querySelectorAll('.np-trio__card'));
    var prevBtn = section.querySelector('#trio-prev');
    var nextBtn = section.querySelector('#trio-next');
    if (!cards.length || !prevBtn || !nextBtn) return;
    section.dataset.trioBound = '1';
    var offset = 0;

    function perPage() { return window.innerWidth >= 768 ? 3 : 1; }
    function render() {
      var pp = perPage();
      cards.forEach(function (c, i) {
        c.classList.toggle('np-trio__card--hidden', i < offset || i >= offset + pp);
      });
      prevBtn.disabled = offset === 0;
      nextBtn.disabled = offset + pp >= cards.length;
    }
    prevBtn.addEventListener('click', function () { if (offset > 0) { offset--; render(); } });
    nextBtn.addEventListener('click', function () { if (offset + perPage() < cards.length) { offset++; render(); } });
    window.addEventListener('resize', function () { offset = 0; render(); }, { passive: true });
    render();
  }

  /* ── Kaching Bundles placement fix ──
     Kaching auto-injects its <kaching-bundle> element right before the product
     form (so it lands at the very top of the buy column, above the badges/H1).
     We want it under the "Select your protocol:" label, so relocate it into
     #endora-gut-protocol as soon as it appears, and keep watching in case
     Kaching re-renders. Moving the live element keeps its listeners intact —
     verified in live QA that the tier cards + add-to-cart still work after the move. */
  function initKachingRelocate() {
    var slot = document.getElementById('endora-gut-protocol');
    if (!slot) return;
    // Kaching inserts <kaching-bundle> as a child of the buy column, right before the
    // form — so watch that one element's direct children, not the whole document.
    var scope = document.querySelector('.endora-gut-atf__info') || document.querySelector('.endora-gut-atf') || document.body;
    function relocate() {
      var kb = document.querySelector('kaching-bundle');
      if (kb && kb.parentElement !== slot) {
        slot.appendChild(kb);
      }
    }
    relocate();
    var observer = new MutationObserver(relocate);
    observer.observe(scope, { childList: true, subtree: true });
    // Kaching has settled well before this; stop watching to free the main thread.
    setTimeout(function () { observer.disconnect(); }, 12000);
  }

  var _globalListenersBound = false;

  function boot() {
    // Above-the-fold / conversion-critical — run now.
    initGallery();
    initPriceBlock();
    initShipDate();
    initStickyBar();
    if (!_globalListenersBound) {
      _globalListenersBound = true;
      initKachingRelocate();
      initGuaranteeNote();
      // Everything else only powers below-the-fold interactions — defer it off the
      // critical path so it doesn't add to Total Blocking Time during first render.
      var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 200); };
      idle(function () {
        initIngredientToggle();
        initSegrevTabs();
        initTrioNav();
        initAccordions();
        initReadMore();
        initPdfModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();
